import React from 'react';

import { block } from 'bem-cn';

import { LANGUAGES } from '../../constants';
import useLocalizedStrings from '../../hooks/useLocalizedStrings';
import Typography from '../Typography';

import './pion-expand-button.scss';

export const translations = {
  [LANGUAGES.EN]: {
    showMore: 'Show more',
    showLess: 'Show less',
  },
  [LANGUAGES.SV]: {
    showMore: 'Mer',
    showLess: 'Mindre',
  },
};

const b = block('pion-expand-button');

type PionExpandButtonPropsType = {
  expanded?: boolean;
  onClick?: () => void;
  type?: string;
  lang: string;
};

const PionExpandButton = ({
  expanded = false,
  onClick,
  type,
  lang,
}: PionExpandButtonPropsType) => {
  const strings = useLocalizedStrings<typeof translations>(translations, lang);

  return (
    <>
      <button
        data-testid='pion-expand-button'
        className={b({ type, expanded })}
        onClick={onClick}
      >
        {expanded && (
          <Typography
            component='span'
            className={b('text').toString()}
            variant={Typography.THEME.VARIANTS.TITLE_MICRO}
            data-testid='text'
          >
            {strings.showLess}
          </Typography>
        )}
        {!expanded && (
          <Typography
            component='span'
            className={b('text').toString()}
            variant={Typography.THEME.VARIANTS.TEXT_SMALL}
            data-testid='text'
          >
            {strings.showMore}
          </Typography>
        )}
      </button>
    </>
  );
};

export default PionExpandButton;
